import { Expose, Type } from 'class-transformer';

import { Default, ExposeRawData } from '@lib/common/decorators';

import { SnIntegrationLayer } from '../integration-layer';
import { SnLayerMeta } from '../layer-meta';

export class SnRedbookMeta extends SnLayerMeta {
  @Expose()
  @Default('')
  public apiUserName: string;

  @Expose()
  @ExposeRawData()
  @Default('')
  public apiPassword: string;

  @Expose()
  @ExposeRawData()
  @Default('')
  public onBehalfOf: string;
}

export class SnRedbookLayer extends SnIntegrationLayer {
  @Expose()
  @Default('Redbook Integration')
  public name: string;

  @Expose()
  @Default('Redbook')
  public integrationType: string;

  @Expose()
  @Type(() => SnRedbookMeta)
  @Default(new SnRedbookMeta())
  public meta: SnRedbookMeta;
}
